export default "__VITE_ASSET__akZRGB8N__"